'use client'
import react, { useState, useEffect } from 'react'
import { useRouter } from 'next/navigation'
import { updateSearchParams, getSearchParams, removeSearchParam, priceFormatter } from "@utils";
import { Combobox, Transition } from "@headlessui/react"
import { rentMaxPrices } from '@constants'
import { RiArrowDropDownLine } from 'react-icons/ri'
import tailwindConfig from '@tailwind.config'

const MaxPriceFilter = ({ title, dictionary, lang }) => {
    const router = useRouter();

    const [selectedMaxPrice, setSelectedMaxPrice] = useState(rentMaxPrices[lang].at(-1))
    const [query, setQuery] = useState('')

    const handleUpdateParams = (e) => {
        const minPriceValue = getSearchParams('minprice')
        if (minPriceValue !== null && Number(e.value) < Number(minPriceValue)) {
            setSelectedMaxPrice({ value: minPriceValue, nom: priceFormatter(minPriceValue) })

            let newPathName = updateSearchParams(title, minPriceValue);

            router.push(newPathName);
            router.refresh()
        } else {
            setSelectedMaxPrice(e)
            // const newPathName = updateSearchParams(title, e.value);
            let newPathName
            if (e.value == '0') {
                newPathName = removeSearchParam(title);
            } else {
                newPathName = updateSearchParams(title, e.value);
            }

            router.push(newPathName);
            router.refresh()
        }
    };

    useEffect(() => {
        const maxPriceValue = getSearchParams('maxprice')
        // setAddChecked(minPriceValue)
        const newValue = rentMaxPrices[lang].find(obj => obj.value === maxPriceValue);

        if (newValue != undefined) {
            setSelectedMaxPrice(newValue)
        } else {
            if (maxPriceValue === null) {
                setSelectedMaxPrice(rentMaxPrices[lang].at(-1))
            } else {
                setSelectedMaxPrice({ value: maxPriceValue, nom: priceFormatter(maxPriceValue) })
            }
        }

    }, [setSelectedMaxPrice])

    const filteredPrices =
        query === ''
            ? rentMaxPrices[lang]
            : rentMaxPrices[lang].filter((price) => {
                if (getSearchParams('minprice') == null) {
                    return price.value.includes(query.toLowerCase())
                } else {
                    return (price.value.includes(query.toLowerCase()) && Number(price.value) >= Number(getSearchParams('minprice')))

                }
            })

    const selectTextOnClick = (e) => {
        e.target.select();
    };

    return (
        <div className='flex flex-col w-1/2 mt-2'>
            <span className='text-sm text-secondary mb-1'>{dictionary.filter.maxPrice}:</span>
            <Combobox value={selectedMaxPrice.nom} onChange={(value) => { handleUpdateParams(value) }}>
                <div className="relative w-full">
                    <div className='z-1 relative w-full cursor-default overflow-hidden rounded-sm bg-white text-left border-[1px] border-forth text-secondary focus:outline-none focus-visible:ring-2 focus-visible:ring-white focus-visible:ring-opacity-75 focus-visible:ring-offset-2 sm:text-sm'>
                        <Combobox.Input onClick={selectTextOnClick} onChange={(event) => setQuery(event.target.value)} required className='w-full border-none py-2 pl-3 pr-10 text-sm leading-5 text-gray-900 focus:ring-0' onFocus={() => {
                            if (window.matchMedia('(max-width: 768px)').matches) {
                                document.querySelector('.text-sm.text-secondary.mb-1').scrollIntoView();
                            }
                        }} />
                        <Combobox.Button className="absolute inset-y-0 right-0 flex items-center pr-2">
                            <RiArrowDropDownLine
                                color={tailwindConfig.theme.extend.colors.secondary}
                                size={28}
                            />
                        </Combobox.Button>
                    </div>
                    <Combobox.Options
                        as="ul" // Render the Combobox.Options as an unordered list (ul) to contain the options
                        className='z-50 left-0 right-0 absolute bg-white h-auto max-h-[200px] overflow-y-auto shadow-md rounded-sm py-1'
                    >
                        {query.length > 0 && (
                            <Combobox.Option
                                value={{ nom: priceFormatter(query), value: query }}
                                className='py-2 px-4 cursor-pointer color-secondary z-50'

                            >
                                {dictionary.filter.searchPrice}: {priceFormatter(query)}
                            </Combobox.Option>
                        )}
                        {filteredPrices.map((price) => (
                            <Combobox.Option
                                key={price.value}
                                value={price}
                                className='py-2 px-4 cursor-pointer color-secondary z-50'
                            >
                                {price.nom}
                            </Combobox.Option>
                        ))}
                    </Combobox.Options>
                </div>
            </Combobox>
        </div>
    )
}

export default MaxPriceFilter